import {
  ChangeDetectorRef, Component, OnInit, Input, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { BaseAdvancedSearchComponent } from 'shared/search/advanced-search/_base-advanced-search.component';
import { StateSearchComponent } from 'shared/search/state-search/state-search.component';
import { TagsSearchComponent } from 'shared/search/tags-search/tags-search.component';
import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';

import { BrandService } from 'shared/brand/brand.service';
import { ReceiversService } from '../receivers.service';


@Component({
  moduleId: module.id,
  selector: 'receivers-advanced-search',
  templateUrl: 'receivers-advanced-search.component.html',
  styleUrls: ['receivers-advanced-search.component.scss'],
})
export class ReceiversAdvancedSearchComponent extends BaseAdvancedSearchComponent implements OnInit {

  @ViewChild(StateSearchComponent, {static: false})
  stateSearch: StateSearchComponent | void;

  @ViewChild(TagsSearchComponent, {static: false})
  tagsSearch: TagsSearchComponent | void;

  tags: string[] = [];

  constructor(
    public brandService: BrandService,
    protected ref: ChangeDetectorRef,
    protected receiversService: ReceiversService,
  ) {
    super(brandService, ref);
  }

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get selectedStateFilters(): ActiveFilterModel[] {
    return this.stateSearch && this.stateSearch.selectedFilters;
  }

  get selectedTagsFilters(): ActiveFilterModel[] {
    return this.tagsSearch && this.tagsSearch.selectedTagsFilters;
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    this.fetchTags();
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public removeFilter(filter: ActiveFilterModel) {
    super.removeFilter(filter);
    if (filter._id === 'tags') {
      if (this.tagsSearch instanceof TagsSearchComponent) {
        this.tagsSearch.deselectFilter(filter);
      }
    }
    if (filter._id === 'state') {
      if (this.stateSearch instanceof StateSearchComponent) {
        this.stateSearch.clearFilter(filter);
      }
    }
  }

  public resetAllData(): void {
    this.clearAllFilters();
  }

  public clearFilters(): void {
    this.clearAllFilters();
  }

  /*******************************************
  * COMPONENT PROTECTED
  *******************************************/

  // redefined parent method
  protected initAdvancedSearch(): void {
    this.setActiveFilters();
    this.fetchTags();
  }

  protected setActiveFilters(): void {
    this.activeFilters = _.filter(this.filters, (filter: any) => {
      return filter._id === 'state' || filter._id === 'tags';
    });
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private fetchTags(): void {
    this.showSpinner(true);
    this.receiversService.fetchTags(this.brandId)
    .subscribe((data: any) => {
      this.tags = data ? _.cloneDeep(data) : [];
      this.showSpinner(false);
    });
  }

  private clearAllFilters() {
    _.remove(this.activeFilters);
    if (this.tagsSearch instanceof TagsSearchComponent) {
      this.tagsSearch.deselectAllFilters();
    }
    if (this.stateSearch instanceof StateSearchComponent) {
      this.stateSearch.clearAllFilters();
    }
  }
}
